import { useState, useEffect } from "react";

import { useAuthContext } from "../../../hooks/useAuthContext";

import { httpGet, httpPut } from "../../../api";

import MDPopup from "../../../components/MDPopup";
import MDTypography from "../../../components/MDTypography";
import MDBox from "../../../components/MDBox";
import MDButton from "../../../components/MDButton";
import MDInput from "../../../components/MDInput";
import MDSelect from "../../../components/MDSelect";


const Page = (props) => {
	const { user, dispatch } = useAuthContext();

	const ticket = props.ticket;

	const [note, setNote] = useState(0);
	const [validSubmit, setValidSubmit] = useState(false);

	const [oldPassword, setOldPassword] = useState("");

	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");

	const [error, setError] = useState(null);

	useEffect(() => {
		if (oldPassword.length > 0 && password.length > 0 && confirmPassword.length > 0){
			if (confirmPassword != password){
				setError("Passwords don't match");
			}else{
				if (password.length < 6){
					setError("Password must be at least 6 characters long");
				}else{
					setError(null);

					setValidSubmit(true);
				}
			}
		}
		
		
	}, [oldPassword, password, confirmPassword])

	useEffect(() => {
		
		setOldPassword("");
		setPassword("");
		setConfirmPassword("");

		setError(null)

		setValidSubmit(false)
	}, [props.open])

	const handleSubmit = async () => {
		const response = await httpPut(process.env.REACT_APP_URL_BASE+`/user/password`, {
              oldPassword: oldPassword,
              newPassword1: password,
              newPassword2: confirmPassword
            })

		if(response.status === 400){
	        response.json().then(data => {
		      alert(data.message);
	        })
        }else if (response.status === 200){
        	alert("Password updated");
        	// Logout the user

        	dispatch({type: "LOGOUT"});
        }else {
        	alert("Something went wrong");

        	console.log(response);
        }
	}


	return <>
		<MDPopup display="flex" flexDirection="column" justifyContent="center" alignItems="center" open={props.open}>
	        <MDTypography variant="h3" color="info" textAlign="center" fontWeight="bold">Update your password</MDTypography>

	        <br />

	        <MDTypography variant="h6" color="text">Old password :</MDTypography>
	          
	        <MDInput type="password" onChange={e => setOldPassword(e.target.value)} />

	        <br />

	        <MDTypography variant="h6" color="text">New password :</MDTypography>

	        <MDInput type="password" error={error} onChange={e => setPassword(e.target.value)} />

	        <br />
	        <MDTypography variant="label" color="error">{error}</MDTypography>
	        <br />

	       	<MDTypography variant="h6" color="text">Confirm new password :</MDTypography>

	       	<MDInput type="password" error={error} onChange={e => setConfirmPassword(e.target.value)} />

	        <br />

	        <MDBox width="70%" textAlign="center">
	          <MDButton onClick={handleSubmit} disabled={!validSubmit} variant="text" color="success">Save</MDButton>
	          <MDButton variant="outlined" color="error" onClick={props.close}>Cancel</MDButton>
	        </MDBox>
	    </MDPopup>
	</>
}

export default Page